module.exports = __webpack_public_path__ + "r-v3/img/coachmark_preview.5bb93a83.png";